<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel } from '../../../pages/cms/marketing/sliders/_runtime/services/SlidersService';
import SlidersService from '../../../pages/cms/marketing/sliders/_runtime/services/SlidersService';

defineOptions({
    name: 'WidgetSliderSettings'
});

interface FormSettings
{
    settings: any;
}

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $t } = useLocalization();

const defaults = ref<any>({
    slider: ''
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const quantity = computed<Option<number>[]>(() =>
{
    return new Array(10).fill(null).map((value, index) =>
    {
        return { value: index + 1, text: (index + 1).toString() };
    });
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            slider: schema.string().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

async function fetchSlider(id: number): Promise<ListItemModel>
{
    if (id != 0)
    {
        const response = await SlidersService.fetchAutocompleteModel(id);

        return response || null;
    }

    return null;
}

async function searchSliders(query: string, limit: number): Promise<ListItemModel[]>
{
    return await SlidersService.getAutocompleteList(query, limit);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    quantity,
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Slajder]]]')" :invalid-feedback="form.$errors.first('settings.slider')" :state="form.$errors.state('settings.slider')" required>
        <IdeoAutocomplete
            v-model="form.settings.slider"
            name="settings.slider"
            track-by="id"
            :placeholder="$t('[[[zacznij pisać aby wyszukać slajder...]]]')"
            :fetch="(id: number) => fetchSlider(id)"
            :search="(query: string, limit: number) => searchSliders(query, limit)"
            :disabled="form.language === null"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </IdeoAutocomplete>
    </IdeoFormGroup>
</template>
